import React, { Component } from 'react';
import { Modal } from 'react-router-modal';
import withEscClose from '../../common/components/withEscClose';

import { ModalContentBlock } from '../../pages/components';
import Button from '../../../ui/button/Button';

const CloseableModal = withEscClose(Modal);

class Dialog extends Component {
  render() {
    const { open, title, children, onCancel, onConfirm, cancelLabel, confirmLabel } = this.props;

    return open ? (
      <CloseableModal onBackdropClick={onCancel}>
        <ModalContentBlock title={title}>
          {children}
          <footer>
            {cancelLabel && (
              <Button theme="light" onClick={onCancel}>
                {cancelLabel}
              </Button>
            )}
            <Button onClick={onConfirm}>{confirmLabel}</Button>
          </footer>
        </ModalContentBlock>
      </CloseableModal>
    ) : null;
  }
}

export default Dialog;



// WEBPACK FOOTER //
// ./src/modules/common/components/Dialog.js